// import GBK from './gbk.min.js';


// http://localhost:8080/visualMap/project?token=1d123&uCloudId=2d12e3&refreshToken=d123331&gpno=4294901762&level=2
export function getQueryParams(url) {
  // 移除URL中的协议头（如http://）
  url = url.substr(url.indexOf('?') + 1);
  // 将URL分割成单独的参数字符串
  let params = decodeURIComponent(url).split('&');
  // 创建一个对象来存储参数
  let queryParams = {};
  params.forEach(param => {
    let keyValue = param.split('=');
    let key = keyValue[0];
    let value = keyValue[1] || '';
    queryParams[key] = value;
  });
  return queryParams;
};

function String2GBKArray(string, fixCount) {
 
  return array2uInt8(GBK.encode(string), fixCount);
}


function Int2uInt8Array(number,fixCount)
{
  let newArray = new Uint8Array(fixCount);
  let index = fixCount ;
  while(index >0){

    let n =  number>> (index-1)*8 & 0xff ;

    console.log(number,'Int2uInt8Array',index,'******',n.toString(16));

    newArray.set( [n],  fixCount- index ); 
    index --

    console.log('newArray',newArray[fixCount- index]);
  }

  return newArray;
}

const FormatterUtf8Array = array2uInt8;



function array2uInt8(array, fixCount) {
  if(!fixCount)
  {
    return array;
  }

  let newArray = new Uint8Array(fixCount);
  if (fixCount >= array.length) {
    newArray.set(array, 0);
  } else {

    newArray.set(array.slice(0, fixCount), 0);
  }
  return newArray;
}

function String2Utf8Array(string, fixCount) {
  const bytes = [];
    
  if(string && string.length > 0)
  {

    let code = encodeURIComponent(string);
    for (var i = 0; i < code.length; i++) {
      const c = code.charAt(i);
      if (c === '%') {
        const hex = code.charAt(i + 1) + code.charAt(i + 2);
        const hexVal = parseInt(hex, 16);
        bytes.push(hexVal);
        i += 2;
      } else bytes.push(c.charCodeAt(0));
    }
  
  }

  return array2uInt8(bytes, fixCount);
}

const hexStr2IntArray = (hexStr) => {

  let array = [];
  for (let i = 0; i < hexStr.length; i += 2) {
      let str = hexStr.substr(i,  2);
      array.push( parseInt(str,16 ));
  } 
  return array;
}

function GBK2UTF8String(array) {
  let a = array.map((value) => {
    return '%' + value.toString(16).toLocaleUpperCase();
  });

  let str = null;
  try {
    str = decodeURIComponent(a.join(''));
  } catch (error) {
    // let b = array.map((value) => {
    //   return '0x' + value.toString(16).toLocaleUpperCase();
    // });
    // str = GBK.decode(b);
  }
  return str;
}

function hexToString(str){
  const arr = hexStr2IntArray(str);

  return GBK2UTF8String(arr);
}

function getStrLength(str) {
  var len = str.length;
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i);
    //中文字符的Unicode编码值范围
    if (c >= 0x4e00 && c <= 0x9fa5) {
      len += 1;
    }
  }
  return len;
}

function isEquealBytes(str, num) {
  const encoder = new TextEncoder(); // 使用TextEncoder来处理UTF-8编码
  const encoded = encoder.encode(str); // 将字符串编码为UTF-8字节序列
  console.log('encoded', encoded.length);
  
  return encoded.length === num; // 判断编码后的字节长度是否为16
}

export {
  hexStr2IntArray,
  getStrLength,
  GBK2UTF8String,
  String2GBKArray,
  String2Utf8Array,
  FormatterUtf8Array,
  Int2uInt8Array,
  hexToString,
  isEquealBytes
};